import { render } from "./IndovinaUEView.vue?vue&type=template&id=24e82b64&class=template"
import script from "./IndovinaUEView.vue?vue&type=script&lang=js"
export * from "./IndovinaUEView.vue?vue&type=script&lang=js"

import "./IndovinaUEView.vue?vue&type=style&index=0&id=24e82b64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__